export const getFontURL = fontFamilyName => {
  const fontfiles = localStorage.getItem('fontFiles');
  if (fontfiles) {
    const customFont = JSON.parse(fontfiles);
    const font = customFont.find((font: any) => font.name === fontFamilyName);
    return font ? font.url : null;
  } else {
    return null;
  }
};
